import { render, staticRenderFns } from "./SeatMapGenerator.vue?vue&type=template&id=23b6d5aa&scoped=true"
import script from "./SeatMapGenerator.vue?vue&type=script&lang=js"
export * from "./SeatMapGenerator.vue?vue&type=script&lang=js"
import style0 from "./SeatMapGenerator.vue?vue&type=style&index=0&id=23b6d5aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b6d5aa",
  null
  
)

export default component.exports